import { Bank } from '@core/model/domain/bank';
import { Mapper } from '@core/model/framework/mapper';
import { BankDto } from '@core/service/digital-factory/bank/types/dto/bankDto';
import { injectable } from 'inversify';

@injectable()
export class BankMapper implements Mapper<Bank, BankDto> {
  toDomain(bankDto: BankDto): Bank {
    return {
      uid: bankDto.uid,
      name: bankDto.name,
      logo: bankDto.logo,
      code: bankDto.code,
      form: bankDto.form,
      authMechanism: bankDto.authMechanism,
    };
  }
}
